import React from 'react';
import { ProductCard } from './ProductCard';
import { EmptySlot } from './EmptySlot';

const SLOTS_PER_SHELF = 7;

interface Product {
  id: string;
  name: string;
  category: string;
  image: string;
  sku: string;
  price: string;
  position?: string;
}

interface ShelfRowProps {
  shelf: number;
  gondola: number;
  products: Product[];
  onDrop: (shelf: number, slot: number) => void;
  onRemove: (shelf: number, slot: number) => void;
  onEdit: (product: Product) => void;
  activeProduct: Product | null;
  isExport?: boolean;
}

export const ShelfRow: React.FC<ShelfRowProps> = ({
  shelf,
  gondola,
  products,
  onDrop,
  onRemove,
  onEdit,
  activeProduct,
  isExport = false
}) => (
  <div className="relative mb-6 last:mb-0">
    <div className="flex items-center gap-2 mb-1.5 px-1">
      <span className="text-[10px] font-black text-muted-foreground uppercase tracking-widest whitespace-nowrap">
        Shelf {shelf}
      </span>
      <div className="h-[1px] flex-1 bg-border" />
    </div>
    <div className="grid grid-cols-7 gap-1.5 sm:gap-2 px-1">
      {Array.from({ length: SLOTS_PER_SHELF }).map((_, slot) => {
        const product = products.find(p => p.position === `${gondola}-${shelf}-${slot}`);
        return (
          <div key={slot} className="relative">
            {product ? (
              <ProductCard product={product} onRemove={() => onRemove(shelf, slot)} onEdit={onEdit} isExport={isExport} />
            ) : (
              <EmptySlot onClick={() => onDrop(shelf, slot)} isActive={!!activeProduct} isExport={isExport} />
            )}
            <span className="absolute -bottom-3 left-1/2 -translate-x-1/2 text-[7px] font-bold text-muted-foreground uppercase">
              P{slot + 1}
            </span>
          </div>
        );
      })}
    </div>
  </div>
);
